import { render, staticRenderFns } from "./SsoIndex.vue?vue&type=template&id=009b3615&scoped=true"
import script from "./SsoIndex.vue?vue&type=script&lang=js"
export * from "./SsoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009b3615",
  null
  
)

export default component.exports